module.exports = __webpack_public_path__ + "img/logo_text_dark-background.71ef1740.svg";